// exp_PORTFOLIO-58018_file
import { push } from 'connected-react-router';
import { convertRegionsFromDto } from 'utils/campaign';
import { VacancyInfoRequirement } from 'utils/campaign/requirementUtils/types';
import { sortAreas } from 'utils/clickme';
import { CREATE_MENU_PAGE_ROUTE } from 'utils/constants/app';

import { Requirements } from 'app/routes';

import store from 'store';
import { RegionBE, setRegions } from 'store/autoReducers';
import type { Action } from 'store/createReducer';
import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { resetVrCampaign, setVrCampaignAreas, setVrCampaignVacancy } from 'store/models/vrCampaign';

export const VrCampaignBuilderPageRequirements: Requirements<{
    regions: RegionBE[];
    vacancyInfo: VacancyInfoRequirement;
}> = {
    methods: ({ state }) => {
        const vacancyId = selectMainMenuVacancyId(state);

        return {
            regions: { url: '/api/v1/catalog/areas' },
            ...(vacancyId && {
                vacancyInfo: { url: `/api/v1/vacancy/campaign_info_from_vacancy?vacancyId=${vacancyId}` },
            }),
        };
    },
    resolve: ({ state, result: { regions, vacancyInfo } }) => {
        const vacancyId = selectMainMenuVacancyId(state);

        if (!vacancyId) {
            store.dispatch(push(CREATE_MENU_PAGE_ROUTE));
            return [];
        }

        const actions: Action[] = [
            resetVrCampaign(null),
            setRegions(sortAreas(convertRegionsFromDto(regions))),
            setVrCampaignVacancy({
                vacancyId,
                vacancyName: vacancyInfo.title,
                vacancyUrl: vacancyInfo.url,
                areaId: vacancyInfo.areaId,
            }),
            setVrCampaignAreas([Number(vacancyInfo.areaId)]),
        ];

        return actions;
    },
};
